(function () {
  if (window.__productDetailsImageLightboxBound) return
  window.__productDetailsImageLightboxBound = true

  const IMAGE_URL_PATTERN = /\.(webp|jpe?g|png|gif|avif|svg)(\?.*)?$/i

  function isImageUrl(href) {
    if (!href || href.startsWith('mailto:') || href.startsWith('tel:')) return false

    try {
      const url = new URL(href, window.location.origin)
      return IMAGE_URL_PATTERN.test(url.pathname)
    } catch {
      return false
    }
  }

  function getModal() {
    let modal = document.getElementById('product-details-image-lightbox')
    if (modal) return modal

    modal = document.createElement('div')
    modal.id = 'product-details-image-lightbox'
    modal.className = 'product-details-image-lightbox'
    modal.hidden = true
    modal.innerHTML =
      '<div class="product-details-image-lightbox__overlay" data-lightbox-overlay>' +
      '<div class="product-details-image-lightbox__dialog" role="dialog" aria-modal="true" aria-label="Image preview">' +
      '<button type="button" class="product-details-image-lightbox__close" data-lightbox-close aria-label="Close">&times;</button>' +
      '<img class="product-details-image-lightbox__image" data-lightbox-image alt="" decoding="async">' +
      '</div></div>'

    document.body.appendChild(modal)

    modal.querySelector('[data-lightbox-close]').addEventListener('click', closeModal)
    modal.querySelector('[data-lightbox-overlay]').addEventListener('click', function (event) {
      if (event.target.matches('[data-lightbox-overlay]')) closeModal()
    })

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && modal && !modal.hidden) closeModal()
    })

    return modal
  }

  let lastTrigger = null

  function openModal(src, alt) {
    const modal = getModal()
    const image = modal.querySelector('[data-lightbox-image]')
    image.src = src
    image.alt = alt || ''
    modal.hidden = false
    document.body.style.overflow = 'hidden'
    modal.querySelector('[data-lightbox-close]').focus()
  }

  function closeModal() {
    const modal = document.getElementById('product-details-image-lightbox')
    if (!modal || modal.hidden) return

    modal.hidden = true
    document.body.style.overflow = ''
    const image = modal.querySelector('[data-lightbox-image]')
    image.removeAttribute('src')
    lastTrigger?.focus()
    lastTrigger = null
  }

  document.addEventListener('click', function (event) {
    const detailsRoot = event.target.closest('[data-swap="product-details-group"]')
    if (!detailsRoot) return

    const link = event.target.closest('a[href]')
    if (!link || !detailsRoot.contains(link)) return

    const href = link.getAttribute('href')
    if (!isImageUrl(href)) return

    event.preventDefault()
    lastTrigger = link
    openModal(href, link.textContent.trim())
  })
})()
